import React from 'react';

import { useApp } from '../store/AppContext';
import PhaseOverrunDialog from './phaseExtendConfirmation/PhaseOverrunDialog';

/* Demande d'allonger la phase quand une affectation dépasse sa date de fin. */
export default function PhaseExtendConfirmation() {
  const { phaseExtendConfirm } = useApp();
  if (!phaseExtendConfirm) return null;
  return (
    <div className="modal-overlay">
      <PhaseOverrunDialog />
    </div>
  );
}
